import * as turf from "@turf/turf";
import { LngLat } from "mapbox-gl";
import { LatLng } from "../map/types";

export const makeColorMatchList = (colorDict: { [key: string]: string }) => {
  let matchList = [];
  for (let key in colorDict) {
    matchList.push(key);
    matchList.push(colorDict[key]);
  }
  matchList.push("#000000");
  return matchList;
};

// To be removed, use lngLatIsInItaly instead
export const pointIsInItaly = (coordinates: turf.helpers.Position) => {
  const italyBbox: turf.helpers.BBox = [4.52339, 35.06508, 20.4766, 47.84898];

  const pointFeature = turf.point(coordinates);
  const bboxPolygon = turf.bboxPolygon(italyBbox);
  const isWithin = turf.booleanPointInPolygon(pointFeature, bboxPolygon);

  return isWithin;
};

export const lngLatIsInItaly = (lngLat: LngLat) => {
  const isWithin =
    lngLat.lng >= 4.52339 && lngLat.lng <= 20.4766 && lngLat.lat >= 35.06508 && lngLat.lat <= 47.84898;
  return isWithin;
};

export const latLngIsInItaly = (latLng: LatLng) => {
  const isWithin =
    latLng.lng >= 4.52339 && latLng.lng <= 20.4766 && latLng.lat >= 35.06508 && latLng.lat <= 47.84898;
  return isWithin;
};
